module.exports = __webpack_public_path__ + "img/nav-markets.c65cebf.svg";